"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vue = _interopRequireDefault(require("vue"));
var _router = _interopRequireDefault(require("@/router"));
var _helpers = require("@/helpers");
var _underLoading = require("../helpers/under-loading");
var _services = require("@/services");
var MutationTypes = _interopRequireWildcard(require("../mutation-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _http = _interopRequireDefault(require("@/config/http"));
var _moment = _interopRequireDefault(require("moment"));
var _utils = require("@/utils");
var _mutations;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t11 in e) "default" !== _t11 && {}.hasOwnProperty.call(e, _t11) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t11)) && (i.get || i.set) ? o(f, _t11, i) : f[_t11] = e[_t11]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var state = {
  services: [],
  service: null,
  schedulePlots: [],
  selectedPlots: [],
  scheduling: null
};
var mutations = (_mutations = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_mutations, MutationTypes.ADD_SERVICES, function (state, _ref) {
  var data = _ref.data;
  state.services = [];
  _vue.default.set(state, 'services', data);
}), MutationTypes.ADD_SCHEDULE_PLOTS, function (state, _ref2) {
  var data = _ref2.data;
  var plots = _lodash.default.cloneDeep(data);
  _vue.default.set(state, 'schedulePlots', plots);
}), MutationTypes.ADD_PLOT_SELECTED, function (state, _ref3) {
  var payload = _ref3.payload;
  var serviceEdit = _lodash.default.cloneDeep(state.service);
  var plots = _lodash.default.cloneDeep(state.schedulePlots);
  plots.map(function (plot) {
    var itemPlot = serviceEdit.plots.find(function (item) {
      return item.id === plot.id;
    });
    if (itemPlot) {
      plot.checked = true;
    }
  });
  _vue.default.set(state, 'schedulePlots', plots);
}), MutationTypes.FORMAT_PLOSTS_SEND_SAVE, function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(state) {
    var plotsItens, plots, subplots, lines, families, bunches, data;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          plotsItens = _lodash.default.cloneDeep(state.selectedPlots);
          plots = [];
          subplots = [];
          lines = [];
          families = [];
          bunches = []; // let promises = plotsItens.map(async (p) => {
          plotsItens.map(/*#__PURE__*/function () {
            var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(p) {
              var subItensPlots;
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    plots.push(p.id);
                    subItensPlots = p.subplots ? p.subplots.filter(function (sub) {
                      return sub.checked === true;
                    }) : [];
                    if (subItensPlots.length) {
                      subItensPlots.map(function (subPlot) {
                        if (subPlot.lines) {
                          var lengthLine = subPlot.lines.filter(function (l) {
                            return l.checked === true;
                          });
                          if (lengthLine.length) {
                            lengthLine.map(function (row) {
                              lines.push(row.id);
                              if (row.families) {
                                var lengthFamilies = row.families.filter(function (l) {
                                  return l.checked === true;
                                });
                                if (lengthFamilies.length) {
                                  lengthFamilies.map(function (familieItem) {
                                    families.push(familieItem.id);
                                    if (familieItem.bunches) {
                                      var filterBunches = familieItem.bunches.filter(function (f) {
                                        return f.checked === true;
                                      });
                                      if (filterBunches.length) {
                                        filterBunches.map(function (buncheItem) {
                                          bunches.push(buncheItem.id);
                                        });
                                      }
                                    }
                                  });
                                }
                              }
                            });
                          }
                        }
                        return subplots.push(subPlot.id);
                      });
                    }
                  case 1:
                    return _context.a(2);
                }
              }, _callee);
            }));
            return function (_x2) {
              return _ref5.apply(this, arguments);
            };
          }());

          // await Promise.all(promises);
          data = {
            plots: plots,
            subplots: subplots,
            lines: lines,
            families: families,
            bunches: bunches
          };
          _vue.default.set(state, 'scheduling', data);
        case 1:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return function (_x) {
    return _ref4.apply(this, arguments);
  };
}()), MutationTypes.ADD_SELECTEDS_ITEMS, function (state) {
  var schedulePlots = _lodash.default.cloneDeep(state.schedulePlots);
  var plots = _lodash.default.filter(schedulePlots, ['checked', true]);
  plots.map(function (plot) {
    for (var _i = 0, _Object$entries = Object.entries(plot); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      if (_lodash.default.isArray(value) && key !== 'center') {
        plot[key] = _lodash.default.filter(plot[key], ['checked', true]);
        plot[key].map(function (child) {
          child.open = false;
          for (var _i2 = 0, _Object$entries2 = Object.entries(child); _i2 < _Object$entries2.length; _i2++) {
            var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
              keyChild = _Object$entries2$_i[0],
              valueChild = _Object$entries2$_i[1];
            if (_lodash.default.isArray(valueChild)) {
              child[keyChild] = _lodash.default.filter(child[keyChild], ['checked', true]);
              child[keyChild].map(function (grandson) {
                grandson.open = false;
                for (var _i3 = 0, _Object$entries3 = Object.entries(grandson); _i3 < _Object$entries3.length; _i3++) {
                  var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
                    keyGrandson = _Object$entries3$_i[0],
                    valueGrandson = _Object$entries3$_i[1];
                  if (_lodash.default.isArray(valueGrandson)) {
                    grandson[keyGrandson] = _lodash.default.filter(grandson[keyGrandson], ['checked', true]);
                    grandson[keyGrandson].map(function (greatGrandson) {
                      for (var _i4 = 0, _Object$entries4 = Object.entries(greatGrandson); _i4 < _Object$entries4.length; _i4++) {
                        var _Object$entries4$_i = _slicedToArray(_Object$entries4[_i4], 2),
                          keyGreatGrandson = _Object$entries4$_i[0],
                          valueGreatGrandson = _Object$entries4$_i[1];
                        if (_lodash.default.isArray(valueGreatGrandson)) {
                          greatGrandson[keyGreatGrandson] = _lodash.default.filter(greatGrandson[keyGreatGrandson], ['checked', true]);
                        }
                      }
                    });
                  }
                }
              });
            }
          }
        });
      }
    }
  });
  _vue.default.set(state, 'selectedPlots', plots);
}), MutationTypes.ADD_SERVICE_SELECT, function (state, _ref6) {
  var payload = _ref6.payload;
  var item = _lodash.default.cloneDeep(payload);
  _vue.default.set(state, 'service', item);
}), MutationTypes.RESET_SERVICE_SELECT, function (state) {
  _vue.default.set(state, 'service', null);
}), MutationTypes.RESET_SERVICES, function (state) {
  _vue.default.set(state, 'services', []);
}), MutationTypes.REMOVE_SELECTED_PLOTS, function (state) {
  _vue.default.set(state, 'selectedPlots', []);
}), MutationTypes.REMOVE_SCHEDULE_PLOTS, function (state) {
  _vue.default.set(state, 'schedulePlots', []);
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_mutations, MutationTypes.EVENT_CHECK_PLOT, function (state, _ref7) {
  var payload = _ref7.payload;
  var plots = _lodash.default.cloneDeep(state.schedulePlots);
  plots.map(function (obj, idx) {
    if (obj.id === payload.id) {
      obj.checked = !obj.checked;
      if (obj.subplots && obj.subplots.length > 0) {
        obj.subplots.map(function (objSub) {
          objSub.checked = obj.checked;
          if (objSub.lines) {
            objSub.lines.map(function (objLine) {
              objLine.checked = objSub.checked;
              if (objLine.families) {
                objLine.families.map(function (objFamilie) {
                  objFamilie.checked = objSub.checked;
                  if (objFamilie.bunches) {
                    objFamilie.bunches.map(function (objBunches) {
                      objBunches.checked = objSub.checked;
                    });
                  }
                });
              }
            });
          }
        });
      }
    }
  });
  _vue.default.set(state, 'schedulePlots', plots);
}), MutationTypes.EVENT_CHECK_SUB_PLOT, function (state, _ref8) {
  var payload = _ref8.payload;
  var plots = _lodash.default.cloneDeep(state.schedulePlots);
  var plot = plots[payload.idxPlot];
  plots.map(function (objPlot) {
    if (objPlot.id === plot.id) {
      if (!objPlot.checked) objPlot.checked = true;
      objPlot.subplots.map(function (objSub) {
        if (payload.hasOwnProperty('all') || objSub.id === payload.idSubPlot) {
          var check = payload.hasOwnProperty('all') ? payload.all : !objSub.checked;
          objSub.checked = check;
          if (objSub.lines) {
            objSub.lines.map(function (objLine) {
              objLine.checked = check;
              if (objLine.families) {
                objLine.families.map(function (objFamilie) {
                  objFamilie.checked = check;
                  if (objFamilie.bunches) {
                    objFamilie.bunches.map(function (objBunches) {
                      objBunches.checked = check;
                    });
                  }
                });
              }
            });
          }
        }
      });
    }
  });
  _vue.default.set(state, 'schedulePlots', plots);
}), MutationTypes.EVENT_CHECK_LINE, function (state, _ref9) {
  var payload = _ref9.payload;
  var plots = _lodash.default.cloneDeep(state.schedulePlots);
  var plot = plots[payload.idxPlot];
  var idSubPlot = payload.idSubPlot;
  var idLine = payload.idLine;
  plots.map(function (objPlot) {
    if (objPlot.id === plot.id) {
      if (!objPlot.checked) objPlot.checked = true;
      objPlot.subplots.map(function (objSub) {
        if (objSub.id === idSubPlot) {
          if (!objSub.checked) objSub.checked = true;
          objSub.lines.map(function (objLine) {
            if (objLine.id === idLine) {
              objLine.checked = !objLine.checked;
              if (objLine.families) {
                objLine.families.map(function (objFamilie) {
                  objFamilie.checked = objLine.checked;
                  if (objFamilie.bunches) {
                    objFamilie.bunches.map(function (objBunches) {
                      objBunches.checked = objLine.checked;
                    });
                  }
                });
              }
            }
          });
        }
      });
    }
  });
  _vue.default.set(state, 'schedulePlots', plots);
}), MutationTypes.EVENT_CHECK_FAMILIES, function (state, _ref0) {
  var payload = _ref0.payload;
  var plots = _lodash.default.cloneDeep(state.schedulePlots);
  var plot = plots[payload.idxPlot];
  var idSubPlot = payload.idSubPlot;
  var idLine = payload.idLine;
  var idFamilie = payload.idFamilie;
  plots.map(function (objPlot) {
    if (objPlot.id === plot.id) {
      if (!objPlot.checked) objPlot.checked = true;
      objPlot.subplots.map(function (objSub) {
        if (objSub.id === idSubPlot) {
          if (!objSub.checked) objSub.checked = true;
          objSub.lines.map(function (objLine) {
            if (objLine.id === idLine) {
              if (!objLine.checked) objLine.checked = true;
              objLine.families.map(function (objFamilie) {
                if (objFamilie.id === idFamilie) {
                  objFamilie.checked = !objFamilie.checked;
                  if (!objFamilie.checked && objFamilie.bunches) {
                    objFamilie.bunches.map(function (objBunches) {
                      objBunches.checked = objFamilie.checked;
                    });
                  }
                }
              });
            }
          });
        }
      });
    }
  });
  _vue.default.set(state, 'schedulePlots', plots);
}), MutationTypes.EVENT_CHECK_BUNCHES, function (state, _ref1) {
  var payload = _ref1.payload;
  var plots = _lodash.default.cloneDeep(state.schedulePlots);
  var plot = plots[payload.idxPlot];
  var idSubPlot = payload.idSubPlot;
  var idRow = payload.idLine;
  var idFamilie = payload.idFamilie;
  var idBunche = payload.idBunche;
  plots.map(function (objPlot) {
    if (objPlot.id === plot.id) {
      if (!objPlot.checked) objPlot.checked = true;
      objPlot.subplots.map(function (objSub) {
        if (objSub.id === idSubPlot) {
          if (!objSub.checked) objSub.checked = true;
          objSub.lines.map(function (objLine) {
            if (objLine.id === idRow) {
              if (!objLine.checked) objLine.checked = true;
              objLine.families.map(function (objFamilie) {
                if (objFamilie.id === idFamilie) {
                  if (!objFamilie.checked) objFamilie.checked = true;
                  objFamilie.bunches.map(function (objBunches) {
                    if (objBunches.id === idBunche) objBunches.checked = !objBunches.checked;
                  });
                }
              });
            }
          });
        }
      });
    }
  });
  _vue.default.set(state, 'schedulePlots', plots);
}), MutationTypes.INSERT_SUBPLOTS_PLOTS, function (state, _ref10) {
  var item = _ref10.item;
  var serviceEdit = _lodash.default.cloneDeep(state.service);
  var plots = _lodash.default.cloneDeep(state.schedulePlots);
  var itemPlot = plots[item.payload.idxPlot];
  plots.map(function (obj) {
    if (obj.id === itemPlot.id) {
      obj.subplots = item.data;
      if (serviceEdit && serviceEdit.subPlots && serviceEdit.subPlots.length > 0 && obj.subplots.length > 0) {
        obj.subplots.map(function (objSub) {
          var itemSub = serviceEdit.subPlots.find(function (i) {
            return i.id === objSub.id;
          });
          if (itemSub) {
            objSub.checked = true;
          }
        });
      }
    }
  });
  _vue.default.set(state, 'schedulePlots', plots);
}), MutationTypes.INSERT_LINES_SUBPLOTS, function (state, _ref11) {
  var item = _ref11.item;
  var plots = item.payload.step === 1 ? _lodash.default.cloneDeep(state.schedulePlots) : _lodash.default.cloneDeep(state.selectedPlots);
  var itemPlot = plots[item.payload.idxPlot];
  var itemSub = item.payload.subPlot;
  var serviceSelected = _lodash.default.cloneDeep(state.service);
  plots.map(function (obj) {
    if (obj.id === itemPlot.id) {
      obj.subplots.map(function (objSub) {
        if (objSub.id === itemSub.id) {
          if (!objSub.hasOwnProperty('checked')) objSub.checked = false;
          if (item.data) {
            if (item.payload.step === 2 && serviceSelected && serviceSelected.rows && serviceSelected.rows.length > 0) {
              objSub.lines = (0, _utils.mergeArrays)(item.data, serviceSelected.rows, 'id', null);
            } else {
              objSub.lines = item.data;
            }
          }
          objSub.open = !objSub.open;
          if (objSub.lines.length > 0 && objSub.checked) {
            objSub.lines.map(function (linesItens) {
              linesItens.checked = objSub.checked;
            });
          }
        } else {
          objSub.open = false;
        }
      });
    }
  });
  var dataSave = item.payload.step === 1 ? 'schedulePlots' : 'selectedPlots';
  _vue.default.set(state, dataSave, plots);
}), MutationTypes.INSERT_FAMILIES_LINE, function (state, _ref12) {
  var item = _ref12.item;
  var plots = item.payload.step === 1 ? _lodash.default.cloneDeep(state.schedulePlots) : _lodash.default.cloneDeep(state.selectedPlots);
  var itemPlot = plots[item.payload.idxPlot];
  var idSubPlot = item.payload.item.parentId;
  var idLine = item.payload.item.id;
  var serviceSelected = _lodash.default.cloneDeep(state.service);
  plots.map(function (obj) {
    if (obj.id === itemPlot.id) {
      obj.subplots.map(function (objSub) {
        if (objSub.lines && objSub.id === idSubPlot) {
          objSub.lines.map(function (objLine) {
            if (objLine.id === idLine) {
              if (!objLine.hasOwnProperty('checked')) objLine.checked = false;
              if (item.payload.step === 2 && serviceSelected && serviceSelected.families && serviceSelected.families.length > 0) {
                objLine.families = (0, _utils.mergeArrays)(item.data, serviceSelected.families, 'id', null);
              } else {
                if (item.data) objLine.families = item.data;
              }
              objLine.open = !objLine.open;
              if (objLine.families && objLine.families.length > 0 && objLine.checked) {
                objLine.families.map(function (familiesItens) {
                  familiesItens.checked = objLine.checked;
                });
              }
            } else objLine.open = false;
          });
        }
      });
    }
  });
  var dataSave = item.payload.step === 1 ? 'schedulePlots' : 'selectedPlots';
  _vue.default.set(state, dataSave, plots);
}), MutationTypes.INSERT_BUNCHES_FAMILIES, function (state, _ref13) {
  var item = _ref13.item;
  var plots = item.payload.step === 1 ? _lodash.default.cloneDeep(state.schedulePlots) : _lodash.default.cloneDeep(state.selectedPlots);
  var itemPlot = plots[item.payload.idxPlot];
  var idSubPlot = item.payload.idSubPlot;
  var idLine = item.payload.item.parentId;
  var idFamilie = item.payload.item.id;
  var serviceSelected = _lodash.default.cloneDeep(state.service);
  plots.map(function (obj) {
    if (obj.id === itemPlot.id) {
      obj.subplots.map(function (objSub) {
        if (objSub.id === idSubPlot) {
          objSub.lines.map(function (objLine) {
            if (objLine.families && objLine.id === idLine) {
              objLine.families.map(function (objFamilie) {
                if (objFamilie.id === idFamilie) {
                  if (!objFamilie.hasOwnProperty('checked')) objFamilie.checked = false;
                  if (item.payload.step === 2 && serviceSelected && serviceSelected.bunches && serviceSelected.bunches.length > 0) {
                    objFamilie.bunches = (0, _utils.mergeArrays)(item.data, serviceSelected.bunches, 'id', null);
                  } else {
                    if (item.data) objFamilie.bunches = item.data;
                  }
                  objFamilie.open = !objFamilie.open;
                } else objFamilie.open = false;
              });
            }
          });
        }
      });
    }
  });
  var dataSave = item.payload.step === 1 ? 'schedulePlots' : 'selectedPlots';
  _vue.default.set(state, dataSave, plots);
}));
var getters = {
  storeServices: function storeServices(state) {
    return state.services;
  },
  serviceSelected: function serviceSelected(state) {
    return state.service;
  },
  schedulePlots: function schedulePlots(state) {
    return state.schedulePlots;
  },
  checkedPlots: function checkedPlots(state) {
    return state.selectedPlots;
  },
  getScheduling: function getScheduling(state) {
    return state.scheduling;
  }
};
var actions = {
  addSeletectedsPlots: function addSeletectedsPlots(_ref14, payload) {
    var commit = _ref14.commit,
      dispatch = _ref14.dispatch;
    commit(MutationTypes.ADD_PLOT_SELECTED, {
      payload: payload
    });
  },
  createSelectedsPlotsItens: function createSelectedsPlotsItens(_ref15) {
    var commit = _ref15.commit,
      dispatch = _ref15.dispatch;
    commit(MutationTypes.ADD_SELECTEDS_ITEMS);
  },
  removeSelectedPlots: function removeSelectedPlots(_ref16) {
    var commit = _ref16.commit,
      dispatch = _ref16.dispatch;
    commit(MutationTypes.REMOVE_SELECTED_PLOTS);
  },
  removeSchedulePlots: function removeSchedulePlots(_ref17) {
    var commit = _ref17.commit,
      dispatch = _ref17.dispatch;
    commit(MutationTypes.REMOVE_SCHEDULE_PLOTS);
  },
  checkedPlot: function checkedPlot(_ref18, payload) {
    var commit = _ref18.commit,
      dispatch = _ref18.dispatch;
    commit(MutationTypes.EVENT_CHECK_PLOT, {
      payload: payload
    });
  },
  checkedSubPlot: function checkedSubPlot(_ref19, payload) {
    var commit = _ref19.commit,
      dispatch = _ref19.dispatch;
    commit(MutationTypes.EVENT_CHECK_SUB_PLOT, {
      payload: payload
    });
  },
  checkedLine: function checkedLine(_ref20, payload) {
    var commit = _ref20.commit,
      dispatch = _ref20.dispatch;
    commit(MutationTypes.EVENT_CHECK_LINE, {
      payload: payload
    });
  },
  checkedFamilies: function checkedFamilies(_ref21, payload) {
    var commit = _ref21.commit,
      dispatch = _ref21.dispatch;
    commit(MutationTypes.EVENT_CHECK_FAMILIES, {
      payload: payload
    });
  },
  checkedBunches: function checkedBunches(_ref22, payload) {
    var commit = _ref22.commit,
      dispatch = _ref22.dispatch;
    commit(MutationTypes.EVENT_CHECK_BUNCHES, {
      payload: payload
    });
  },
  addServiceSelected: function addServiceSelected(_ref23, payload) {
    var commit = _ref23.commit,
      dispatch = _ref23.dispatch;
    commit(MutationTypes.ADD_SERVICE_SELECT, {
      payload: payload
    });
  },
  resetServiceSelected: function resetServiceSelected(_ref24) {
    var commit = _ref24.commit,
      dispatch = _ref24.dispatch;
    commit(MutationTypes.RESET_SERVICE_SELECT);
  },
  resetServices: function resetServices(_ref25) {
    var commit = _ref25.commit,
      dispatch = _ref25.dispatch;
    commit(MutationTypes.RESET_SERVICES);
  },
  // eslint-disable-trailing-spaces
  fetchServices: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref27 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref26, payload) {
      var commit, rootState, params, _yield$servicesServic, data, _t;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            commit = _ref26.commit, rootState = _ref26.rootState;
            _context3.p = 1;
            params = {
              farm: rootState.farm.farm.id
            };
            params = Object.assign(params, payload);
            _context3.n = 2;
            return _services.servicesService.fetchServices(params);
          case 2:
            _yield$servicesServic = _context3.v;
            data = _yield$servicesServic.data;
            commit(MutationTypes.ADD_SERVICES, {
              data: data
            });
            return _context3.a(2, data);
          case 3:
            _context3.p = 3;
            _t = _context3.v;
            _helpers.errorResponseHelper.display(_t);
            return _context3.a(2, false);
        }
      }, _callee3, null, [[1, 3]]);
    }));
    return function (_x3, _x4) {
      return _ref27.apply(this, arguments);
    };
  }()),
  fetchServicesFinisheds: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref29 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_ref28, payload) {
      var commit, rootState, params, _yield$servicesServic2, data, _t2;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            commit = _ref28.commit, rootState = _ref28.rootState;
            _context4.p = 1;
            params = {
              farm: rootState.farm.farm.id
            };
            params = Object.assign(params, payload);
            _context4.n = 2;
            return _services.servicesService.fetchServicesFinisheds(params);
          case 2:
            _yield$servicesServic2 = _context4.v;
            data = _yield$servicesServic2.data;
            return _context4.a(2, data);
          case 3:
            _context4.p = 3;
            _t2 = _context4.v;
            _helpers.errorResponseHelper.display(_t2);
            return _context4.a(2, false);
        }
      }, _callee4, null, [[1, 3]]);
    }));
    return function (_x5, _x6) {
      return _ref29.apply(this, arguments);
    };
  }()),
  fetchServiceItem: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref31 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(_ref30, id) {
      var commit, rootState, _yield$servicesServic3, data, _t3;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            commit = _ref30.commit, rootState = _ref30.rootState;
            _context5.p = 1;
            _context5.n = 2;
            return _services.servicesService.fetchServiceItem(id);
          case 2:
            _yield$servicesServic3 = _context5.v;
            data = _yield$servicesServic3.data;
            return _context5.a(2, data);
          case 3:
            _context5.p = 3;
            _t3 = _context5.v;
            _helpers.errorResponseHelper.display(_t3);
            return _context5.a(2, false);
        }
      }, _callee5, null, [[1, 3]]);
    }));
    return function (_x7, _x8) {
      return _ref31.apply(this, arguments);
    };
  }()),
  fetchServiceDetailItem: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref33 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(_ref32, id) {
      var commit, rootState, _yield$servicesServic4, data, _t4;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            commit = _ref32.commit, rootState = _ref32.rootState;
            _context6.p = 1;
            _context6.n = 2;
            return _services.servicesService.fetchServiceDetailItem(id);
          case 2:
            _yield$servicesServic4 = _context6.v;
            data = _yield$servicesServic4.data;
            return _context6.a(2, data);
          case 3:
            _context6.p = 3;
            _t4 = _context6.v;
            _helpers.errorResponseHelper.display(_t4);
            return _context6.a(2, false);
        }
      }, _callee6, null, [[1, 3]]);
    }));
    return function (_x9, _x0) {
      return _ref33.apply(this, arguments);
    };
  }()),
  deleteService: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref35 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(_ref34, payload) {
      var commit, rootState, service, idService, params, response, successMessage, _t5;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            commit = _ref34.commit, rootState = _ref34.rootState;
            _context7.p = 1;
            service = _lodash.default.cloneDeep(payload && payload.deleteArquived ? payload : state.service);
            idService = service.id;
            params = {};
            if (payload && payload.deleteRecurrent) params.deleteRecurrent = payload.deleteRecurrent;
            _context7.n = 2;
            return _services.servicesService.deleteService(idService, params);
          case 2:
            response = _context7.v;
            successMessage = _router.default.app.$t('pages.services.alerts.delete_service_success');
            _helpers.messageHelper.success(successMessage);
            return _context7.a(2, response);
          case 3:
            _context7.p = 3;
            _t5 = _context7.v;
            _helpers.errorResponseHelper.display(_t5);
            return _context7.a(2, false);
        }
      }, _callee7, null, [[1, 3]]);
    }));
    return function (_x1, _x10) {
      return _ref35.apply(this, arguments);
    };
  }()),
  saveNewScheduling: function () {
    var _saveNewScheduling = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(_ref36, payload) {
      var rootState, commit, dispatch, scheduling, idStepService, serviceTypes, typeService, data, dueDate, response, path, _t6;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.p = _context8.n) {
          case 0:
            rootState = _ref36.rootState, commit = _ref36.commit, dispatch = _ref36.dispatch;
            _context8.p = 1;
            _context8.n = 2;
            return commit(MutationTypes.FORMAT_PLOSTS_SEND_SAVE);
          case 2:
            // buscando arrays formatados
            scheduling = _lodash.default.cloneDeep(state.scheduling); // id do agendamento
            idStepService = state.service ? state.service.id : null; // detalhes do tipo de servico
            serviceTypes = rootState.typeService.serviceTypes;
            typeService = serviceTypes.find(function (i) {
              return i.id === payload.typeService;
            });
            data = {
              name: typeService.name ? typeService.name : state.service.name,
              typeId: typeService.id ? typeService.id : state.service.id,
              cycle: payload.cycle,
              os: payload.os,
              workersId: [],
              occurrenciesId: [],
              batchsId: [],
              endRecurrenceDate: '',
              clientsId: []
            };
            if (payload.batchsId) data.batchsId = payload.batchsId.map(function (e) {
              return e.id;
            });
            if (payload.clientsId) data.clientsId = payload.clientsId;
            if (payload.endRecurrenceDate) data.endRecurrenceDate = payload.endRecurrenceDate;
            // itens personalizados
            if (payload.status) data.status = payload.status;
            dueDate = (0, _moment.default)(payload.date).format('YYYY-MM-DD');
            if (dueDate) data.dueDate = (0, _moment.default)(dueDate).toISOString();
            if (scheduling && scheduling.plots.length > 0) data.plotsId = scheduling.plots;
            if (scheduling && scheduling.subplots.length > 0) data.subPlotsId = scheduling.subplots;
            if (scheduling && scheduling.lines.length > 0) data.rowsId = scheduling.lines;
            if (scheduling && scheduling.families.length > 0) data.familiesId = scheduling.families;
            if (scheduling && scheduling.bunches.length > 0) data.bunchesId = scheduling.bunches;
            if (payload.recurrenceType) data.recurrenceType = payload.recurrenceType;
            if (payload.selfAllocatable) data.selfAllocatable = payload.selfAllocatable;else data.selfAllocatable = false;
            if (payload.logs) data.logs = payload.logs;
            if (payload.finishingDescription) data.finishingDescription = payload.finishingDescription;
            if (payload.hasOwnProperty('archived')) data.archived = payload.archived;
            if (payload.workers.length > 0) {
              payload.workers.map(function (item) {
                data.workersId.push(item.id);
              });
            }
            if (payload.occurrencies.length > 0) {
              payload.occurrencies.map(function (item) {
                data.occurrenciesId.push(item.id);
              });
            }
            if (payload.customFields && payload.customFields.length > 0) {
              data.customFields = payload.customFields;
            }
            if (state.service) {
              // data.typeId = state.service ? state.service.type.id : payload.type.id
              data.id = idStepService;
            }
            delete data.__v;
            response = null;
            path = !state.service ? "/services" : "/services/".concat(idStepService);
            if (state.service) {
              _context8.n = 4;
              break;
            }
            _context8.n = 3;
            return _http.default.post(path, data);
          case 3:
            response = _context8.v;
            _context8.n = 6;
            break;
          case 4:
            _context8.n = 5;
            return _http.default.put(path, data);
          case 5:
            response = _context8.v;
          case 6:
            return _context8.a(2, Promise.resolve(response));
          case 7:
            _context8.p = 7;
            _t6 = _context8.v;
            return _context8.a(2, Promise.reject(_t6));
        }
      }, _callee8, null, [[1, 7]]);
    }));
    function saveNewScheduling(_x11, _x12) {
      return _saveNewScheduling.apply(this, arguments);
    }
    return saveNewScheduling;
  }(),
  updateScheduling: function () {
    var _updateScheduling = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(_ref37, payload) {
      var commit, dispatch, idStepService, data, path, response, _t7;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.p = _context9.n) {
          case 0:
            commit = _ref37.commit, dispatch = _ref37.dispatch;
            _context9.p = 1;
            idStepService = payload.id;
            data = payload;
            path = "/services/".concat(idStepService);
            _context9.n = 2;
            return _http.default.put(path, data);
          case 2:
            response = _context9.v;
            return _context9.a(2, Promise.resolve(response.data));
          case 3:
            _context9.p = 3;
            _t7 = _context9.v;
            return _context9.a(2, Promise.reject(_t7));
        }
      }, _callee9, null, [[1, 3]]);
    }));
    function updateScheduling(_x13, _x14) {
      return _updateScheduling.apply(this, arguments);
    }
    return updateScheduling;
  }(),
  fectchServiceProgess: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref39 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(_ref38, payload) {
      var commit, rootState, _yield$servicesServic5, data, _t8;
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.p = _context0.n) {
          case 0:
            commit = _ref38.commit, rootState = _ref38.rootState;
            _context0.p = 1;
            _context0.n = 2;
            return _services.servicesService.fectchServiceProgess(state.service.id);
          case 2:
            _yield$servicesServic5 = _context0.v;
            data = _yield$servicesServic5.data;
            return _context0.a(2, data);
          case 3:
            _context0.p = 3;
            _t8 = _context0.v;
            _helpers.errorResponseHelper.display(_t8);
            return _context0.a(2, false);
        }
      }, _callee0, null, [[1, 3]]);
    }));
    return function (_x15, _x16) {
      return _ref39.apply(this, arguments);
    };
  }()),
  fetchServiceCustomFieldValues: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref41 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(_ref40, payload) {
      var commit, rootState, _yield$servicesServic6, data, _t9;
      return _regenerator().w(function (_context1) {
        while (1) switch (_context1.p = _context1.n) {
          case 0:
            commit = _ref40.commit, rootState = _ref40.rootState;
            _context1.p = 1;
            _context1.n = 2;
            return _services.servicesService.fetchServiceCustomFieldValues(payload);
          case 2:
            _yield$servicesServic6 = _context1.v;
            data = _yield$servicesServic6.data;
            return _context1.a(2, data);
          case 3:
            _context1.p = 3;
            _t9 = _context1.v;
            _helpers.errorResponseHelper.display(_t9);
            return _context1.a(2, false);
        }
      }, _callee1, null, [[1, 3]]);
    }));
    return function (_x17, _x18) {
      return _ref41.apply(this, arguments);
    };
  }()),
  fetchValuesCFStepsFinisheds: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref43 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(_ref42, params) {
      var commit, rootState, _yield$servicesServic7, data, _t0;
      return _regenerator().w(function (_context10) {
        while (1) switch (_context10.p = _context10.n) {
          case 0:
            commit = _ref42.commit, rootState = _ref42.rootState;
            _context10.p = 1;
            _context10.n = 2;
            return _services.servicesService.fetchValuesCFStepsFinisheds(params);
          case 2:
            _yield$servicesServic7 = _context10.v;
            data = _yield$servicesServic7.data;
            return _context10.a(2, data);
          case 3:
            _context10.p = 3;
            _t0 = _context10.v;
            _helpers.errorResponseHelper.display(_t0);
            return _context10.a(2, false);
        }
      }, _callee10, null, [[1, 3]]);
    }));
    return function (_x19, _x20) {
      return _ref43.apply(this, arguments);
    };
  }()),
  updateServiceFinished: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref46 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(_ref44, _ref45) {
      var commit, rootState, id, payload, _yield$servicesServic8, data, _t1;
      return _regenerator().w(function (_context11) {
        while (1) switch (_context11.p = _context11.n) {
          case 0:
            commit = _ref44.commit, rootState = _ref44.rootState;
            id = _ref45.id, payload = _ref45.payload;
            _context11.p = 1;
            _context11.n = 2;
            return _services.servicesService.updateServiceFinished(id, payload);
          case 2:
            _yield$servicesServic8 = _context11.v;
            data = _yield$servicesServic8.data;
            return _context11.a(2, data);
          case 3:
            _context11.p = 3;
            _t1 = _context11.v;
            _helpers.errorResponseHelper.display(_t1);
            return _context11.a(2, false);
        }
      }, _callee11, null, [[1, 3]]);
    }));
    return function (_x21, _x22) {
      return _ref46.apply(this, arguments);
    };
  }()),
  deleteServiceFinished: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref48 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(_ref47, id) {
      var commit, rootState, _yield$servicesServic9, data, _t10;
      return _regenerator().w(function (_context12) {
        while (1) switch (_context12.p = _context12.n) {
          case 0:
            commit = _ref47.commit, rootState = _ref47.rootState;
            _context12.p = 1;
            _context12.n = 2;
            return _services.servicesService.deleteServiceFinished(id);
          case 2:
            _yield$servicesServic9 = _context12.v;
            data = _yield$servicesServic9.data;
            return _context12.a(2, data);
          case 3:
            _context12.p = 3;
            _t10 = _context12.v;
            _helpers.errorResponseHelper.display(_t10);
            return _context12.a(2, false);
        }
      }, _callee12, null, [[1, 3]]);
    }));
    return function (_x23, _x24) {
      return _ref48.apply(this, arguments);
    };
  }())
};
var _default = exports.default = {
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
};